import React, { Fragment, LazyExoticComponent } from "react";

import { Route } from "react-router-dom";

interface IPublicRoute {
  component: LazyExoticComponent<React.ComponentType<any>>;
  layout?: React.ComponentType<any>;
}

const PublicRoute: React.FC<IPublicRoute> = ({
  component: Component,
  layout,
  ...rest
}) => {
  const Layout = layout ? layout : Fragment;
  return (
    <Route
      {...rest}
      render={(props: any) => (
        <Layout>
          <Component {...props} />
        </Layout>
      )}
    />
  );
};

export default PublicRoute;
